import { useState, useEffect, memo } from "react";
import { Badge } from "@/components/ui/badge";
import { Users, TrendingUp, CheckCircle2, Zap } from "lucide-react";

interface ActivityMessage {
  id: string;
  icon: typeof Users;
  message: string;
  highlight?: string;
  color: string;
}

const activities: ActivityMessage[] = [
  {
    id: "1",
    icon: Users,
    message: "47 profesionales se registraron",
    highlight: "esta semana",
    color: "text-primary",
  },
  {
    id: "2",
    icon: TrendingUp,
    message: "+120% de crecimiento",
    highlight: "este mes",
    color: "text-green-500",
  },
  {
    id: "3",
    icon: CheckCircle2,
    message: "María de Madrid",
    highlight: "acaba de registrarse",
    color: "text-amber-500",
  },
  {
    id: "4",
    icon: Zap,
    message: "15 reservas procesadas",
    highlight: "última hora",
    color: "text-blue-500",
  },
  {
    id: "5",
    icon: Users,
    message: "Carlos de Barcelona",
    highlight: "activó su perfil",
    color: "text-primary",
  },
];

export const LiveActivityBar = memo(() => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % activities.length);
        setIsVisible(true);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const current = activities[currentIndex];
  const Icon = current.icon;

  return (
    <div className="bg-gradient-to-r from-primary/5 via-primary/10 to-primary/5 border-b border-primary/10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center py-2 gap-3">
          <Badge variant="outline" className="bg-green-500/10 text-green-600 border-green-500/30 animate-pulse">
            <span className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-ping" />
            EN VIVO
          </Badge>
          
          <div
            className={`flex items-center gap-2 transition-all duration-300 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
            }`}
          >
            <Icon className={`w-4 h-4 ${current.color}`} />
            <span className="text-sm">
              <span className="font-medium">{current.message}</span>
              {current.highlight && (
                <span className="text-muted-foreground ml-1">{current.highlight}</span>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});

LiveActivityBar.displayName = "LiveActivityBar";
